import type { StrictColor } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";

import type { ExtensionUserStatus } from "app/pages/sales-intelligence/modules/extension-management/types";

export const ACTIVE_DAYS_WARNING_THRESHOLD = 10;

export const STATUS_FILTER_ALL = "all" as const;

export type StatusFilterValue = ExtensionUserStatus | typeof STATUS_FILTER_ALL;

export const STATUS_BG_COLOR_MAP: Record<ExtensionUserStatus, StrictColor> = {
    Active: colorsPalettes.mint["50"],
    Inactive: colorsPalettes.carbon["25"],
    NotInstalled: colorsPalettes.red["100"],
};

export const STATUS_TEXT_COLOR_MAP: Record<ExtensionUserStatus, StrictColor> = {
    Active: colorsPalettes.mint["400"],
    Inactive: colorsPalettes.carbon["250"],
    NotInstalled: colorsPalettes.red["400_P"],
};

export const STATUS_LABEL_MAP: Record<ExtensionUserStatus, string> = {
    Active: "si.management.extension.governance.status.active",
    Inactive: "si.management.extension.governance.status.inactive",
    NotInstalled: "si.management.extension.governance.status.not_installed",
};

export const STATUS_FILTER_OPTIONS: StatusFilterValue[] = [STATUS_FILTER_ALL, "Active", "NotInstalled", "Inactive"];

export const STATUS_FILTER_LABEL_MAP: Record<StatusFilterValue, string> = {
    [STATUS_FILTER_ALL]: "si.management.extension.governance.filter.all",
    Active: "si.management.extension.governance.filter.active",
    Inactive: "si.management.extension.governance.filter.inactive",
    NotInstalled: "si.management.extension.governance.filter.not_installed",
};
